import { EventsName } from '../constants'

import type { ToggleRichTextModalEvent } from './types'

export const togglePostModalEventDispatch = (payload: ToggleRichTextModalEvent) =>
  window.dispatchEvent(new CustomEvent(EventsName.MODAL_RICH_TEXT, { detail: payload }))

export const togglePostModalEventListener = (listener: (event: Event) => void) => {
  window.addEventListener(EventsName.MODAL_RICH_TEXT, listener)

  return () => window.removeEventListener(EventsName.MODAL_RICH_TEXT, listener)
}
